import type { TDomainConfig } from '~~/brands';

export function useDomainConfig(): TDomainConfig {
  const domainConfigs = useRuntimeConfig().public.brand.domainConfigs as TDomainConfig[];
  const hostname = useRequestURL().hostname;

  return domainConfigs.find(({ domain }) =>
    hostname === domain || hostname.endsWith(`.${domain}`)
  ) || domainConfigs[0]!;
}
